import axios from '@/utils/axios'

export default async function GetRelatedProducts({ queryKey }: any) {
  const params = queryKey[1]
  const prd_id = params['product_id']
  const cat_id = params['category_id']
  const gender = params['gender']
  const country = params['country'] || 'us'
  const currency = params['currency'] || 'USD'
  
  const { data } = await axios.get(
    `${process.env.NEXT_PUBLIC_API_URL}/products/get-related-products/${prd_id}/${cat_id}/${gender}`,
    {
      params: {
        country,
        currency
      }
    }
  )
  return data
}